// extracted by mini-css-extract-plugin
module.exports = {"container":"Thumbnail_container__2X6IU","image":"Thumbnail_image__1goER"};